/*
  Adventsonntage – gemeinsame Logik der Vorlage product.advent-sundays
  - Die Größenkarten (Block „Advent sizes“ in main-product) wählen die Variante in der
    gewohnten Größenwahl der Kaufbox; Preis und alle Mengenangaben ([data-adv-qty])
    folgen der gewählten Größe.
  - Nach Fristende ([data-adv-deadline]) oder ohne Bestand: html.ec-adv-closed,
    Kaufknopf aus mit Text „vergeben“. Die Handy-Kaufleiste spiegelt den Knopf.
  - Sektionen mit [data-adv-reveal] blenden beim Scrollen weich ein.
  Die Datei wird von mehreren Sektionen eingebunden und läuft nur einmal.
*/
(function () {
  if (window.ECAdvent) return;

  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var state = { closed: false, closedLabel: '', variants: [], index: 1 };

  window.ECAdvent = {
    close: close,
    isClosed: function () { return state.closed; }
  };

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  ready(init);

  function init() {
    readVariants();
    initSizes();
    initVariantSync();
    initClosing();
    initReveal();
  }

  /* ---------- Varianten und Mengen ---------- */

  function readVariants() {
    var el = document.querySelector('[data-adv-variants]');
    if (!el) return;
    try {
      state.variants = JSON.parse(el.textContent) || [];
    } catch (e) {
      state.variants = [];
    }
    var sizes = document.querySelector('ec-advent-sizes');
    if (sizes && sizes.dataset.closedLabel) state.closedLabel = sizes.dataset.closedLabel;
  }

  function indexOf(id) {
    for (var i = 0; i < state.variants.length; i++) {
      if (String(state.variants[i].id) === String(id)) return i + 1;
    }
    return 0;
  }

  function applyVariant(id) {
    var idx = indexOf(id);
    if (!idx) return;
    state.index = idx;
    var v = state.variants[idx - 1];

    document.querySelectorAll('[data-adv-qty]').forEach(function (el) {
      var text = el.getAttribute('data-v' + idx) || el.getAttribute('data-v1');
      if (text != null && el.textContent !== text) el.textContent = text;
    });
    document.querySelectorAll('[data-adv-price]').forEach(function (el) {
      if (v && v.price) el.textContent = v.price;
    });
    document.querySelectorAll('.ec-adv-size__input').forEach(function (input) {
      input.checked = String(input.value) === String(id);
    });
  }

  function initSizes() {
    document.querySelectorAll('ec-advent-sizes').forEach(function (sizes) {
      var picker = document.querySelector('product-variants[data-id="' + sizes.dataset.section + '"]');
      sizes.addEventListener('change', function (e) {
        var input = e.target.closest('.ec-adv-size__input');
        if (!input) return;
        e.stopPropagation();
        applyVariant(input.value);
        if (!picker) return;
        var option = input.getAttribute('data-option');
        var radios = picker.querySelectorAll('.product-variant__input');
        for (var i = 0; i < radios.length; i++) {
          if (radios[i].value === option) {
            radios[i].checked = true;
            radios[i].dispatchEvent(new Event('change', { bubbles: true }));
            break;
          }
        }
      });
    });
  }

  function initVariantSync() {
    document.querySelectorAll('product-variants').forEach(function (picker) {
      picker.addEventListener('VARIANT_CHANGE', function () {
        if (picker.currentVariant) applyVariant(picker.currentVariant.id);
        // Die Theme-Logik schaltet den Knopf bei jedem Wechsel neu – danach wieder sperren
        if (state.closed) lockButtons();
      });
      if (picker.currentVariant) applyVariant(picker.currentVariant.id);
    });
  }

  /* ---------- Frist und Bestand ---------- */

  function initClosing() {
    if (root.classList.contains('ec-adv-closed')) {
      close();
    }

    var soldOut = state.variants.length > 0 && state.variants.every(function (v) { return !v.available; });
    if (soldOut) close();

    var el = document.querySelector('[data-adv-deadline]');
    var end = el ? Date.parse(el.getAttribute('data-adv-deadline')) : NaN;
    if (!isNaN(end)) {
      var left = end - Date.now();
      if (left <= 0) {
        close();
      } else if (left < 2147483647) {
        setTimeout(close, left + 500);
      }
    }

    // Formulare der Kaufbox nach Fristende nicht mehr abschicken (auch nicht über die Handy-Leiste)
    document.addEventListener('submit', function (e) {
      if (!state.closed) return;
      var form = e.target;
      if (form && form.matches && form.matches('form[action*="/cart/add"]') && form.closest('.ec-advent-product')) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);
  }

  function close() {
    state.closed = true;
    root.classList.add('ec-adv-closed');
    lockButtons();
  }

  function lockButtons() {
    document.querySelectorAll('.ec-advent-product form[action*="/cart/add"]').forEach(function (form) {
      form.classList.add('disabled-cart');
      form.querySelectorAll('[data-js-product-add-to-cart]').forEach(function (btn) {
        btn.classList.add('disabled');
        btn.setAttribute('aria-disabled', 'true');
        var text = btn.querySelector('[data-js-product-add-to-cart-text]');
        if (text && state.closedLabel && text.textContent.trim() !== state.closedLabel) {
          text.textContent = state.closedLabel;
        }
      });
    });
  }

  /* ---------- Einblenden ---------- */

  function initReveal() {
    var items = document.querySelectorAll('[data-adv-reveal]');
    if (!items.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }
})();
